import DictionaryKeyContent from './DictionaryKeyContent';

export default DictionaryKeyContent;
